import React from "react";
import Layout from "../components/organisms/Layout";
import Details from "../components/pages/product-detail/Details";
import Technology from "../components/pages/product-detail/Technology";
import Insurance from "../components/molecules/InsuranceList";

const productDetail = () => {
  return (
    <Layout>
      <Details />
      <Technology />
      <Insurance title="Una amplia gama de seguros" />
    </Layout>
  );
};

export default productDetail;
